module.exports = __webpack_public_path__ + "img/Tessellate38.84a7330f.jpg";